import React from 'react';
import { Box, FormControl, FormHelperText, FormLabel, Typography } from '@mui/material';
import type { BaseFieldProps } from './types';

/**
 * Base field component that provides common layout and functionality
 * for all field types
 */
export const BaseField: React.FC<BaseFieldProps & { children: React.ReactNode }> = ({
  field,
  mode = 'edit',
  error,
  touched,
  sx,
  showLabel = true,
  disabled,
  children,
}) => {
  const isDisabled = disabled || mode === 'preview';
  const label = 'label' in field ? field.label : '';
  const required = 'required' in field ? field.required : false;

  // In display mode, just show the children without form control wrapper
  if (mode === 'display') {
    return <Box sx={sx}>{children}</Box>;
  }

  return (
    <FormControl
      fullWidth
      error={!!(touched && error)}
      disabled={isDisabled}
      sx={sx}
    >
      {showLabel && label && (
        <FormLabel component="legend" sx={{ mb: 1 }}>
          {label}
          {required && (
            <Typography component="span" color="error" sx={{ ml: 0.5 }}>
              *
            </Typography>
          )}
        </FormLabel>
      )}
      {children}
      {touched && error && (
        <FormHelperText>{error}</FormHelperText>
      )}
    </FormControl>
  );
};